const LOGIN = '/api/login/'
const LOGOUT = '/api/logout/'
const SIGNUP = '/api/signup/'
const SETUP2FA = '/api/setup_2fa/'
const VERIFY2FA = '/api/verify_2fa/'

const EMAIL_PASSWORD_RESET = '/api/password_reset_email/'
const CHANGE_PASSWORD = '/api/change_password/'

const QUOTE_SEARCH = '/api/quotes/search'
const QUOTE_GET = '/api/quote/search-action'
const DASHBOARD_MARGIN = '/api/dashboard/margin'
const PURCHASE_RESEARCH_CREATE_MULTIPLE = '/api/purchase_research/create/multiple'
const DASHBOARD_MARGIN_REMOVE = '/api/dashboard/margin/remove'
const DASHBOARD_MARGIN_ADD = '/api/dashboard/margin/add'
const DASHBOARD_MARGIN_CHART = '/api/dashboard/margin/chart'
const DASHBOARD_MARGIN_DETAIL = '/api/dashboard/sales/chart/detail'

// DashboardMatchSaleQuote
const DASHBOARD_SALES_MATCH_QUOTE_FILTER_DATE = '/api/dashboard/sales/match_quote/filter_date'
const DASHBOARD_SALES_MATCH_QUOTE = '/api/dashboard/sales/match_quote'
const DASHBOARD_SALES_MATCH_QUOTE_BY_FUZZY_REFERENCE =
    '/api/dashboard/sales/match_quote/by_fuzzy_reference'
const DASHBOARD_SALES_MATCH_QUOTE_CREATE_MATCH = '/api/dashboard/sales/match_quote/create_match'
const DASHBOARD_SO_PO_DETAIL = '/api/dashboard/so_po/detail'
// DashboardParts && DashboardPartHisotry && Dashboard POSO
const DASHBOARD_PARTS = '/api/dashboard/parts'
const DASHBOARD_PARTS_HISTORY = '/api/dashboard/parts/history'
const DASHBOARD_SOPO_DETAIL = '/api/dashboard/so_po/detail'
const DASHBOARD_PARTS_STREAM_STOCK = '/api/dashboard/parts/stream/stock'
const DASHBOARD_PARTS_CHECK_STOCK = '/api/dashboard/parts/check_stock'

// Dashboard POSO
const DASHBOARD_SOPO = '/api/dashboard/so_po'

// Dashboard Purchase
const DASHBOARD_PURCHASE = '/api/dashboard/purchase'
const PURCHASE_RESEARCH_UPDATE_PURCHASE = '/api/purchase_research/update_purchased'

// Dashboard Pricing Analysis
const PRICING_ACTIONS_APPROVAL = '/api/pricing/actions/approval'
const DASHBOARD_PRICING_ANALYSIS = '/api/dashboard/pricing/analysis'
const DASHBOARD_PRICING_ANALYSIS_DETAILS = '/api/dashboard/pricing/analysis/details'
const DASHBOARD_PURCHASE_RESEARCH_UPDATE_PURCHASED = '/api/purchase_research/update_purchased'

// Dashboard Quotes Chart
const DASHBOARD_SALES = '/api/dashboard/sales'
const DASHBOARD_QUOTE_CHART = '/api/dashboard/quotes/chart'
const DASHBOARD_SALES_CHART_DETAIL = '/api/dashboard/sales/chart/detail'

// Dashboard Quotes
const DASHBOARD_QUOTES = '/api/dashboard/quotes'

// Dashboard RULES
const DASHBOARD_RULES_SUMMARY = '/api/rules/summary'

// Dashboard RULES DETAIS
const DASHBOARD_RULES = '/api/rules'
const DASHBOARD_RULES_DETAILS = '/api/rule/detail'

const DASHBOARD_SALES_CHART_NEW = '/api/dashboard/sales/chart_new'
const DASHBOARD_PRICING = '/api/dashboard/pricing'
const DASHBOARD_UPLOAD_SPECIAL_PRICING = '/api/upload/special_pricing'

const DASHBOARD_ERRORS = '/api/dashboard/errors'

const DASHBOARD_PARTS_PRICING_SPREADSHEET_UPLOAD = '/api/dashboard/parts/pricing_spreadsheet_upload'
const DASHBOARD_PARTS_SHIPPING_SPREADSHEET_UPLOAD = '/api/dashboard/shipping_spreadsheet_upload'

const DASHBOARD_SHIPPING = '/api/dashboard/shipping'

const AUTH_AND_INITIALIZE = '/api/auth_and_initialize'
const ACCOUNTS_LOGIN = 'accounts/login/'

const DASHBOARD_SALES_CHART = '/api/dashboard/sales/chart'

const PREFECT_SEARCH_POLL = '/api/prefect_search/poll'
const SEARCH_PARTSDB = '/api/search/partsdb'
const USER_NOTE_ARCHIVE = '/api/user_note/archive'
const SEARCHACTION_FINISH = '/api/searchaction/quote_finished'
const QUOTE_CREATE = '/api/quote'
const QUOTE_UPDATE_REASON = '/api/quote/update/reason'
const PURCHASE_RESEARCH_CREATE = '/api/purchase_research/create'
const USER_NOTE_CREATE = '/api/user_note/create'
const ADMIN_NOTE_CREATE = '/api/admin_note/create'
const USER_NOTE_GET = '/api/search/notes'
const QUOTE_EDIT_PART = '/api/quotes/edit_part'
const SEARCHACTION_EDIT_PARTS = '/api/searchaction/parts'
const SEARCHACTION_EDIT_CUSTOMER_REFERENCE = '/api/searchaction/customer_reference'
const STREAM_QUOTE = '/api/stream/quote'
const STREAM_RESEARCH = '/api/stream/research/'
const STREAM_PART = '/api/search'
const STREAM_PART_PARTS = '/api/search/google-search'
const TEST_PARTS_DB = '/api/test/partsdb'
const SEARCH_PART_BANNER_ALERT = '/api/search/check_banner_alert'
const UPDATE_PART_BANNER_ALERT = '/api/search/update_banner_alert'
const SEARCH_SESSION_BY_SEARCH_ACTION_ID = '/api/search/session/search_action_id'
const SEARCH_ACTION_BY_SEARCH_ACTION_ID = '/api/searchaction'
const DASHBOARD_PRICING_FOLLOWUP = '/api/dashboard/pricing/followup'
const PRICING_FOLLOWUP_EDIT = '/api/pricing/followup/edit'
const QUOTE_ASSIGN_REQUESTER = '/api/quote/assign_requester'

// LIVE SEARCH ENDPOINTS
const LIVE_SEARCH = '/api/live-search/'
const ADMIN_LIVE_SEARCH_FLOW_CONFIGURATION = '/api/admin/flow-configurations/live-search'
const ADMIN_LIVE_SEARCH_FLOW_CONFIGURATION_VENDORS =
    '/api/admin/flow-configurations/live-search/vendors'

// SUBSTITUTES ENDPOINTS
const SUBSTITUTE_PARTS = '/api/substitute-parts-tree'
const APPROVE_BAD_SUBSTITUTE = '/api/approve-bad-substitute'
const BAD_SUBSTITUTE_REQUESTS = '/api/bad-substitutes-requests'
const REMOVE_SUBSTITUTE_LINK = '/api/remove-substitute-link'
const REQUEST_REMOVE_SUBSTITUTE = '/api/request-substitutes-remove'
const MASTER_SUBSTITUTES = '/api/master-substitute-parts'

// SEACH ACTION ENDPOINTS
const SEARCHACTION_CUSTOMER_REFERENCE = '/api/searchaction/customer_reference'
const SEARCHACTION_AND_QUOTE_QUOTE_TYPES = '/api/searchaction/{id}/quotes/quote_type'
const SEARCHACTION_INVENTORY = '/api/searchaction/{id}/inventory'
const SEARCHACTION_QUOTES = '/api/searchaction/quotes'
const SEARCHACTION = '/api/searchaction'

// QUOTES ENDPOINTS
const QUOTE_TYPES = '/api/quote/quote_types'
const QUOTE_NO_QUOTE_REASONS = '/api/quote/no-quote-reasons'
const QUOTE_AGGREGATED_DATA = '/api/quote/aggregated-quote-data'

// SEARCH ENDPOINTS
const SEARCH_QUOTE_AGGREGATED_DATA = '/api/search/aggregated-quote-data'
const SEARCH_VENDORS_PARTS = '/api/search/parts'
const SEARCH_PART_MINIMUMS = '/api/gsa/parts-minimums'
const CUSTOMER_CREATE = '/api/customer/create'

export {
    TEST_PARTS_DB,
    PREFECT_SEARCH_POLL,
    SEARCH_PARTSDB,
    USER_NOTE_ARCHIVE,
    SEARCHACTION_FINISH,
    DASHBOARD_PRICING_FOLLOWUP,
    PRICING_FOLLOWUP_EDIT,
    QUOTE_ASSIGN_REQUESTER,
    QUOTE_CREATE,
    QUOTE_UPDATE_REASON,
    PURCHASE_RESEARCH_CREATE,
    USER_NOTE_CREATE,
    ADMIN_NOTE_CREATE,
    QUOTE_EDIT_PART,
    SEARCHACTION_EDIT_PARTS,
    SEARCHACTION_EDIT_CUSTOMER_REFERENCE,
    STREAM_QUOTE,
    STREAM_RESEARCH,
    STREAM_PART,
    QUOTE_SEARCH,
    QUOTE_GET,
    DASHBOARD_MARGIN,
    PURCHASE_RESEARCH_CREATE_MULTIPLE,
    DASHBOARD_MARGIN_REMOVE,
    DASHBOARD_MARGIN_ADD,
    DASHBOARD_MARGIN_CHART,
    DASHBOARD_MARGIN_DETAIL,
    DASHBOARD_SALES_MATCH_QUOTE_FILTER_DATE,
    DASHBOARD_SALES_MATCH_QUOTE,
    DASHBOARD_SALES_MATCH_QUOTE_BY_FUZZY_REFERENCE,
    DASHBOARD_SALES_MATCH_QUOTE_CREATE_MATCH,
    DASHBOARD_SO_PO_DETAIL,
    DASHBOARD_PARTS,
    DASHBOARD_SOPO_DETAIL,
    DASHBOARD_PARTS_STREAM_STOCK,
    DASHBOARD_PARTS_CHECK_STOCK,
    DASHBOARD_SOPO,
    DASHBOARD_PURCHASE,
    PURCHASE_RESEARCH_UPDATE_PURCHASE,
    PRICING_ACTIONS_APPROVAL,
    DASHBOARD_PRICING_ANALYSIS,
    DASHBOARD_PRICING_ANALYSIS_DETAILS,
    DASHBOARD_PURCHASE_RESEARCH_UPDATE_PURCHASED,
    DASHBOARD_SALES,
    DASHBOARD_QUOTE_CHART,
    DASHBOARD_SALES_CHART_DETAIL,
    DASHBOARD_QUOTES,
    DASHBOARD_RULES,
    DASHBOARD_RULES_DETAILS,
    DASHBOARD_RULES_SUMMARY,
    DASHBOARD_SALES_CHART_NEW,
    DASHBOARD_PRICING,
    DASHBOARD_UPLOAD_SPECIAL_PRICING,
    DASHBOARD_ERRORS,
    DASHBOARD_PARTS_PRICING_SPREADSHEET_UPLOAD,
    DASHBOARD_PARTS_SHIPPING_SPREADSHEET_UPLOAD,
    DASHBOARD_SHIPPING,
    AUTH_AND_INITIALIZE,
    ACCOUNTS_LOGIN,
    DASHBOARD_SALES_CHART,
    DASHBOARD_PARTS_HISTORY,
    LOGIN,
    LOGOUT,
    SIGNUP,
    SETUP2FA,
    VERIFY2FA,
    EMAIL_PASSWORD_RESET,
    CHANGE_PASSWORD,
    SEARCH_QUOTE_AGGREGATED_DATA,
    STREAM_PART_PARTS,
    SEARCH_VENDORS_PARTS,
    LIVE_SEARCH,
    ADMIN_LIVE_SEARCH_FLOW_CONFIGURATION,
    ADMIN_LIVE_SEARCH_FLOW_CONFIGURATION_VENDORS,
    SEARCH_PART_MINIMUMS,
    USER_NOTE_GET,
    SEARCH_PART_BANNER_ALERT,
    UPDATE_PART_BANNER_ALERT,
    SEARCH_SESSION_BY_SEARCH_ACTION_ID,
    SEARCH_ACTION_BY_SEARCH_ACTION_ID,
    SUBSTITUTE_PARTS,
    APPROVE_BAD_SUBSTITUTE,
    BAD_SUBSTITUTE_REQUESTS,
    REMOVE_SUBSTITUTE_LINK,
    REQUEST_REMOVE_SUBSTITUTE,
    SEARCHACTION_CUSTOMER_REFERENCE,
    QUOTE_TYPES,
    QUOTE_NO_QUOTE_REASONS,
    QUOTE_AGGREGATED_DATA,
    SEARCHACTION_QUOTES,
    SEARCHACTION,
    SEARCHACTION_AND_QUOTE_QUOTE_TYPES,
    SEARCHACTION_INVENTORY,
    MASTER_SUBSTITUTES,
    CUSTOMER_CREATE,
}
